import { render } from "./InfoPageView.vue?vue&type=template&id=5ff9fa66&scoped=true"
import script from "./InfoPageView.vue?vue&type=script&lang=js"
export * from "./InfoPageView.vue?vue&type=script&lang=js"

import "./InfoPageView.vue?vue&type=style&index=0&id=5ff9fa66&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ff9fa66"]])

export default __exports__